import API from '../index';
import { Order } from '../../types/common';

const approveAdjustment = async (orderId: string, shipmentId: string): Promise<Order> => {
  const data: Order = await API.post(`/orders/${orderId}/confirm-adjustment`, {
    shipmentRef: shipmentId,
    confirm: true,
  });
  return data;
};

export default approveAdjustment;
